import React, { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import axios from "axios";
import config from "../../../config";
import { CircularProgress, Box, Button, Card, CardContent, Typography, Grid } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const ChatFeedbackDetail = () => {
  const { chat_feedback_id } = useParams();
  const navigate = useNavigate();
  const [feedback, setFeedback] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchFeedback = async () => {
      try {
        setLoading(true);
        const response = await axios.get(
          `${config.API_BASE_URL_V1}/admin/chat-feedback/${chat_feedback_id}`
        );

        if (response.data.success && response.data.data) {
          setFeedback(response.data.data);
        } else {
          setError(response.data.message || "Failed to fetch feedback");
        }
      } catch (err) {
        console.error("Error fetching feedback:", err);
        setError(`Error loading feedback: ${err.message}`);
      } finally {
        setLoading(false);
      }
    };

    if (chat_feedback_id) {
      fetchFeedback();
    }
  }, [chat_feedback_id]);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box p={3}>
        <Button
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate("/client-feedback")}
          sx={{ mb: 2 }}
        >
          Back to Feedback
        </Button>
        <Typography color="error">{error}</Typography>
      </Box>
    );
  }

  if (!feedback) {
    return (
      <Box p={3}>
        <Button
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate("/client-feedback")}
          sx={{ mb: 2 }}
        >
          Back to Feedback
        </Button>
        <Typography>Feedback not found</Typography>
      </Box>
    );
  }

  const formatValue = (value) =>
    value === null || value === undefined || value === "" ? "N/A" : value;

  return (
    <>
      {/* Breadcrumb */}
      <div className="breadcrumb-card">
        <h5>Chat Feedback Details</h5>
        <ul className="breadcrumb">
          <li>
            <Link to="/">
              <i className="material-symbols-outlined">home</i>
              Home
            </Link>
          </li>
          <li>
            <Link to="/client-feedback">Client Feedback</Link>
          </li>
          <li>Details</li>
        </ul>
      </div>

      {/* Content */}
      <div className="chat-transcripts-content">
        <Button
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate("/client-feedback")}
          sx={{ mb: 2 }}
        >
          Back to Feedback
        </Button>

        <Card>
          <CardContent>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                <Typography variant="subtitle2" color="textSecondary">
                  Chat Feedback ID
                </Typography>
                <Typography variant="body1">{formatValue(feedback.chat_feedback_id)}</Typography>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Typography variant="subtitle2" color="textSecondary">
                  Store Name
                </Typography>
                <Typography variant="body1">{formatValue(feedback.store_name)}</Typography>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Typography variant="subtitle2" color="textSecondary">
                  Client User Name
                </Typography>
                <Typography variant="body1">{formatValue(feedback.client_user_name)}</Typography>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Typography variant="subtitle2" color="textSecondary">
                  Status
                </Typography>
                <Typography variant="body1">{formatValue(feedback.resolution_status)}</Typography>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Typography variant="subtitle2" color="textSecondary">
                  Created Date
                </Typography>
                <Typography variant="body1">{formatValue(feedback.created_date)}</Typography>
              </Grid>

              <Grid item xs={12}>
                <Typography variant="subtitle2" color="textSecondary">
                  Feedback
                </Typography>
                <Typography variant="body1" style={{ whiteSpace: "pre-wrap" }}>
                  {formatValue(feedback.remarks)}
                </Typography>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </div>
    </>
  );
};

export default ChatFeedbackDetail;

